import { callEndpointWithPayload } from '../baseApi';

export const CloneItem = async ( user, payload) => {
    return await callEndpointWithPayload(`${process.env.REACT_APP_API}/copy`, 'POST', user.idToken, payload)
  }
